// Import global styles
require('normalize.css')

exports.onClientEntry = () => {}
